import React, { useState } from "react";
import OrderModal from "./OrderModal";
import { stripeConfigFor } from "../config/stripe";

// Legacy hosted Stripe Payment Links — used only until an embedded Buy Button id
// is added for the product in /src/config/stripe.js.
const LEGACY_STRIPE_LINKS = {
  "Lokahi Yoga Mat Cleaner": "https://buy.stripe.com/9B67sK0IX8XDaKz4lHcs804",
  "Pō Mahina Magnesium Recovery Spray": "https://buy.stripe.com/7sY7sKcrFddT6uj3hDcs803",
};

const legacyStripeLinkFor = (item) => LEGACY_STRIPE_LINKS[item?.name] || null;

const NEW_COLLECTION = [
  {
    id: "lokahi-yoga-mat-cleaner",
    name: "Lokahi Yoga Mat Cleaner",
    price: "$15.00",
    numericPrice: 15,
    logo: "/images/lokahi-logo.png",
    logoAlt: "Lōkahi — Yoga Mat Cleaner",
    description:
      "A yoga mat cleanser and conditioner that begins and ends every experience on the mat.",
    ingredients: "Organic witch hazel, kukui nut oil, sandalwood, lavender",
  },
  {
    id: "aloha-mahina-magnesium-spray",
    name: "Pō Mahina Magnesium Recovery Spray",
    price: "$30.00",
    numericPrice: 30,
    logo: "/images/po-mahina-logo.png",
    logoAlt: "Pō Mahina Magnesium Recovery Spray — Moon Phases",
    description:
      "Luxury Hawaiian magnesium recovery spray for muscle recovery, deeper sleep, and post-workout relief — under island moonlight.",
    ingredients:
      "Kukui nut oil, organic magnesium, violet essential oil, sandalwood essential oil, cedar wood essential oil, carmine oil",
  },
];

const ComingSoonItem = ({ item, onBuy }) => (
  <div className="coming-soon-item">
    {item.logo ? (
      <div className="coming-soon-icon">
        <img
          src={item.logo}
          alt={item.logoAlt}
          className="coming-soon-logo"
          style={{ width: "340px", height: "340px", objectFit: "contain" }}
        />
      </div>
    ) : null}
    <h3 className="heading-3">{item.name}</h3>
    <p className="body-regular coming-soon-description">{item.description}</p>
    <div className="ingredients-preview">
      <h4 className="heading-4">Key Ingredients:</h4>
      <p className="body-small ingredients-list">{item.ingredients}</p>
      <p className="body-small shake-instruction"><em>Shake Well, separation is Natural</em></p>
    </div>
    <div className="coming-soon-price">
      <span className="price-amount">{item.price}</span>
    </div>
    <div className="product-available">
      {stripeConfigFor(item.name) ? (
        <div
          className="stripe-buy-button-wrap"
          data-testid={`buy-now-${item.id}`}
        >
          <stripe-buy-button
            buy-button-id={stripeConfigFor(item.name).buyButtonId}
            publishable-key={stripeConfigFor(item.name).publishableKey}
          ></stripe-buy-button>
        </div>
      ) : legacyStripeLinkFor(item) ? (
        <a
          className="btn-primary"
          href={legacyStripeLinkFor(item)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`buy-now-${item.id}`}
        >
          Buy Now
        </a>
      ) : (
        <button
          className="btn-primary"
          onClick={onBuy}
          data-testid={`buy-now-${item.id}`}
        >
          Buy Now
        </button>
      )}
    </div>
  </div>
);

const ComingSoonSection = () => {
  const [activeProduct, setActiveProduct] = useState(null);

  return (
    <section className="section-padding coming-soon-section">
      <div className="container">
        <div className="section-header">
          <h2 className="heading-1">NEW to Our Collection</h2>
          <p className="body-large section-subtitle">
            Expanding our island wellness collection with new natural essentials
          </p>
        </div>

        <div className="coming-soon-products">
          {NEW_COLLECTION.map((item) => (
            <ComingSoonItem
              key={item.id}
              item={item}
              onBuy={() => setActiveProduct(item)}
            />
          ))}
        </div>
      </div>

      {activeProduct && (
        <OrderModal
          product={activeProduct}
          onClose={() => setActiveProduct(null)}
        />
      )}
    </section>
  );
};

export default ComingSoonSection;
